import { Bell } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNotificationNudge } from "@/hooks/useNotificationNudge";

interface NotificationNudgeModalProps {
  enabled?: boolean;
}

export const NotificationNudgeModal = ({ enabled = true }: NotificationNudgeModalProps) => {
  const { shouldShow, isDenied, dismiss, enable } = useNotificationNudge({ enabled });

  return (
    <Dialog open={shouldShow} onOpenChange={open => !open && dismiss()}>
      <DialogContent className="top-1/2 -translate-y-1/2 max-w-[90vw] sm:max-w-md" hideClose>
        <DialogHeader className="text-center">
          <div className="mx-auto mb-2 w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-900/30 dark:to-blue-800/30 border border-blue-200 dark:border-blue-700/50 flex items-center justify-center">
            <Bell className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          </div>
          <DialogTitle className="text-center">Never miss a moment</DialogTitle>
          <DialogDescription className="text-center">
            {isDenied
              ? "Notifications are turned off. Enable them in Settings to get notified when your stashes are done processing and when you set reminders."
              : "Get notified when your stashes are done processing and when you set reminders."}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 w-full pt-2 pb-4">
          <Button onClick={() => void enable()} variant="gradient" size="modal" className="w-full">
            {isDenied ? "Open Settings" : "Enable Notifications"}
          </Button>
          <Button onClick={dismiss} variant="secondary" size="modal" className="w-full">
            Maybe Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
